"use client";

import { useReducedMotion } from "motion/react";
import type { ComponentProps, ReactNode } from "react";
import VideoPlayer from "@/components/mdx/video-player";
import DemoCaption from "@/components/preview/demo-caption";

export interface MDXVideoProps extends ComponentProps<"video"> {
  caption?: ReactNode;
  captionHref?: string;
  playbackRate?: number;
  src: string;
}

export function MDXInlineVideo({
  src,
  width,
  height,
  className,
  ...rest
}: ComponentProps<"video">) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <video
      autoPlay={!prefersReducedMotion}
      className={className}
      controls={Boolean(prefersReducedMotion)}
      height={height ?? 630}
      loop
      muted
      playsInline
      preload="metadata"
      src={src}
      width={width ?? 1200}
      {...rest}
    />
  );
}

export function MDXBlockVideo({
  caption,
  captionHref,
  className,
  src,
  width,
  height,
  ...rest
}: MDXVideoProps) {
  return (
    <div className="my-8 w-full">
      <VideoPlayer
        {...rest}
        className={className}
        height={height}
        src={src}
        width={width}
      />
      {caption && <DemoCaption href={captionHref}>{caption}</DemoCaption>}
    </div>
  );
}
